import { IdentityProviderResponse } from '@/types';
import { getApiBaseUrl } from '../config/env';

const IDENTITY_API_BASE = getApiBaseUrl();
export const DEFAULT_TENANT_UUID = '00000000-0000-0000-0000-000000000000';

export function resolveIdentityLookupKey(subdomain?: string): string {
  const normalized = (subdomain || '').trim();
  return normalized || DEFAULT_TENANT_UUID;
}

export async function fetchIdentityProviderBySubdomain(
  subdomain?: string
): Promise<IdentityProviderResponse> {
  const identityLookupKey = resolveIdentityLookupKey(subdomain);

  const response = await fetch(
    `${IDENTITY_API_BASE}/identity/${encodeURIComponent(identityLookupKey)}`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }
  );

  if (!response.ok) {
    throw new Error(`Identity lookup failed (${response.status})`);
  }

  const data = (await response.json()) as IdentityProviderResponse;

  if (!data || !data.clientId || !data.provider) {
    throw new Error('Identity response is invalid');
  }

  return data;
}
